import React from 'react';

import Tag from '@atlaskit/tag/removable-tag';

const cupcakeipsum = 'Croissant tiramisu gummi bears.';

export default (): React.JSX.Element => <Tag text={cupcakeipsum} isRemovable={false} />;
